(function () {
  var TIMER_FLAG = '__shPreOrderFomoTimers';

  function interpolate(now, startTs, endTs, startValue, endValue) {
    if (now >= endTs) return endValue;
    if (now <= startTs) return startValue;
    var duration = endTs - startTs;
    if (duration <= 0) return endValue;
    return startValue + (endValue - startValue) * ((now - startTs) / duration);
  }

  function tenthsFrom(now, startTs, endTs, startValue, endValue) {
    var duration = endTs - startTs;
    if (now >= endTs || now <= startTs || duration <= 0) {
      return Math.trunc(interpolate(now, startTs, endTs, startValue, endValue) * 10);
    }
    var elapsed = now - startTs;
    var delta = endValue - startValue;
    var progressTenths = Math.trunc((delta * 10 * elapsed) / duration);
    return Math.trunc(startValue * 10) + progressTenths;
  }

  function formatPercent(tenths) {
    var whole = Math.trunc(tenths / 10);
    var tenth = Math.abs(tenths % 10);
    if (tenth !== 0) return whole + ',' + tenth + '%';
    return whole + '%';
  }

  function writeText(node, text) {
    if (!node) return;
    if (node.textContent !== text) node.textContent = text;
  }

  function updateFomoBar(bar) {
    var now = Math.floor(Date.now() / 1000);
    var startValue = parseFloat(bar.getAttribute('data-start-value')) || 0;
    var endValue = parseFloat(bar.getAttribute('data-end-value')) || 0;
    var startTs = parseInt(bar.getAttribute('data-start-ts'), 10) || 0;
    var endTs = parseInt(bar.getAttribute('data-end-ts'), 10) || 0;
    var suffix = bar.getAttribute('data-suffix') || '';
    var lowMax = parseFloat(bar.getAttribute('data-low-max'));
    var midMax = parseFloat(bar.getAttribute('data-mid-max'));
    if (isNaN(lowMax)) lowMax = 15;
    if (isNaN(midMax)) midMax = 25;

    var percentTenths = tenthsFrom(now, startTs, endTs, startValue, endValue);
    var currentNode = bar.querySelector('[data-sh-fomo-current]');
    var suffixNode = bar.querySelector('.sh-pre-order-fomo__suffix');
    var suffixText = String(suffix).replace(/^\s+/, '');

    writeText(currentNode, formatPercent(percentTenths));
    if (suffixNode && suffixNode.textContent !== suffixText) suffixNode.textContent = suffixText;

    var width = Math.min(100, Math.max(0, percentTenths / 10));
    var widthText = String(Math.trunc(width * 10) / 10) + '%';
    var fill = bar.querySelector('.sh-pre-order-fomo__bar-fill');
    if (fill && fill.style.width !== widthText) fill.style.width = widthText;

    var compare = Math.trunc(percentTenths / 10);
    var color = bar.getAttribute('data-color-mid') || '#fbd343';
    if (compare <= lowMax) color = bar.getAttribute('data-color-low') || '#f76962';
    else if (compare > midMax) color = bar.getAttribute('data-color-high') || '#77a464';

    var wrap = bar.closest('.sh-pre-order-fomo');
    if (wrap) {
      var currentAccent = (wrap.style.getPropertyValue('--sh-po-fomo-accent') || '').trim();
      if (currentAccent.toLowerCase() !== String(color).toLowerCase()) {
        wrap.style.setProperty('--sh-po-fomo-accent', color);
      }
    }

    var ariaNow = String(Math.round(Math.min(100, Math.max(0, width))));
    if (bar.getAttribute('aria-valuenow') !== ariaNow) bar.setAttribute('aria-valuenow', ariaNow);
  }

  function updateFomoCountdown(el) {
    var endTs = parseInt(el.getAttribute('data-end-ts'), 10) || 0;
    var now = Math.floor(Date.now() / 1000);
    if (now >= endTs) {
      var wrap = el.closest('.sh-pre-order-fomo');
      el.remove();
      if (wrap && !wrap.querySelector('[data-sh-fomo-bar]') && !wrap.querySelector('.sh-pre-order-fomo__text')) {
        wrap.remove();
      }
      return;
    }

    var remaining = endTs - now;
    var days = Math.floor(remaining / 86400);
    var hours = Math.floor((remaining % 86400) / 3600);
    var minutes = Math.floor((remaining % 3600) / 60);
    var seconds = remaining % 60;
    var amounts = { D: days, H: hours, M: minutes, S: seconds };
    var labels = (el.getAttribute('data-labels') || 'D|M|S').split('|');
    var parts = [];
    labels.forEach(function (label) {
      var token = label.trim();
      var amount = amounts[token.toUpperCase()];
      if (amount == null || token === '') return;
      parts.push(amount + token);
    });
    var text = parts.join(' : ');
    var timeNode = el.querySelector('[data-sh-fomo-countdown-time]');
    writeText(timeNode, text);
  }

  function enforceFomoWindow() {
    if (window.Shopify && window.Shopify.designMode) return;
    var now = Math.floor(Date.now() / 1000);
    document.querySelectorAll('[data-sh-fomo-ab]').forEach(function (el) {
      var start = parseInt(el.getAttribute('data-start-ts'), 10) || 0;
      var end = parseInt(el.getAttribute('data-end-ts'), 10) || 0;
      if ((start && now < start) || (end && now >= end)) el.remove();
    });
  }

  function variantMap(el) {
    if (el._shFomoVariants) return el._shFomoVariants;
    var node = el.querySelector('[data-sh-fomo-variants]');
    var list = [];
    try {
      list = JSON.parse(node ? node.textContent : '[]');
    } catch (error) {
      list = [];
    }
    var map = {};
    list.forEach(function (variant) {
      if (variant && variant.id != null) map[String(variant.id)] = variant;
    });
    el._shFomoVariants = map;
    return map;
  }

  function variantIsAllowed(record) {
    return !!(record && record.available && record.requires_shipping);
  }

  function applyVariantGate(variant) {
    if (window.Shopify && window.Shopify.designMode) return;
    document.querySelectorAll('[data-sh-fomo-ab]').forEach(function (el) {
      var allowed;
      var id = variant && variant.id != null ? String(variant.id) : '';
      if (id) {
        var known = variantMap(el)[id];
        if (known) {
          allowed = variantIsAllowed(known);
        } else if (typeof variant.available === 'boolean') {
          allowed = variant.available && variant.requires_shipping !== false;
        } else {
          return;
        }
      } else {
        allowed = el.getAttribute('data-product-available') === 'true' && el.getAttribute('data-product-ships') === 'true';
      }
      if (allowed) el.removeAttribute('data-sh-fomo-blocked');
      else el.setAttribute('data-sh-fomo-blocked', '');
    });
  }

  function onVariantEvent(event) {
    applyVariantGate(event.detail && event.detail.variant);
  }

  function initFomo(root) {
    enforceFomoWindow();
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-sh-fomo-countdown]').forEach(updateFomoCountdown);
    scope.querySelectorAll('[data-sh-fomo-bar]').forEach(updateFomoBar);
  }

  function tickCountdown() {
    enforceFomoWindow();
    document.querySelectorAll('[data-sh-fomo-countdown]').forEach(updateFomoCountdown);
  }

  function tickBars() {
    document.querySelectorAll('[data-sh-fomo-bar]').forEach(updateFomoBar);
  }

  function boot(root) {
    if (!window[TIMER_FLAG]) {
      window[TIMER_FLAG] = true;
      window.setInterval(tickCountdown, 1000);
      window.setInterval(tickBars, 10000);
    }
    initFomo(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });

  document.addEventListener('variant:change', onVariantEvent);
  document.addEventListener('variant:changed', onVariantEvent);
})();
